module.exports = __webpack_public_path__ + "static/blog44-42bd8ba9025c5b207717cb9d48e72c92.png";